import { isHiddenPlansOnly, serverPricingToClientPriceAndCurrencyString, } from './pp';
export const serverPricingToClientPrice = (serverPricing) => {
    if (!serverPricing || !serverPricing.singlePayment) {
        return '';
    }
    return serverPricing.singlePayment.price.amount;
};
export const serverPricingToClientCurrency = (serverPricing) => {
    var _a, _b;
    return ((_b = (_a = serverPricing === null || serverPricing === void 0 ? void 0 : serverPricing.singlePayment) === null || _a === void 0 ? void 0 : _a.price) === null || _b === void 0 ? void 0 : _b.currency) || '';
};
export const getClientIsPriceEnabled = (pricing) => Boolean(pricing && pricing.singlePayment && pricing.singlePayment.price);
export const getChallengePaidPlans = (challengeId, userPaidPlans = []) => userPaidPlans.filter((plan) => (plan.challenges || []).includes(challengeId));
export const getChallengeVisiblePaidPlans = (challengeId, userPaidPlans = []) => {
    return (getChallengePaidPlans(challengeId, userPaidPlans) || []).filter(isPaidPlanActive);
};
export const isChallengeFree = (pricing, challengePaidPlansLength) => !((pricing && pricing.singlePayment) || challengePaidPlansLength);
export const isPaidPlanActive = (paidPlan) => {
    return paidPlan.visible !== false; // this weird check is needed
};
export function getPaidPlansJoinedName(t, challengePaidPlans = [], joinedKey, forActivePlansOnly = false) {
    var _a, _b;
    const plans = forActivePlansOnly
        ? challengePaidPlans.filter(isPaidPlanActive)
        : challengePaidPlans;
    if (!plans.length) {
        return '';
    }
    return plans.length === 1
        ? ((_b = (_a = plans[0]) === null || _a === void 0 ? void 0 : _a.details) === null || _b === void 0 ? void 0 : _b.name) || ''
        : t(joinedKey, {
            count: plans.length,
        });
}
export const serverToClientPricing = (t, challenge, userPaidPlans = [], freeKey, separatorKey, joinedKey, hiddenPlansOnlyKey, ignoreHidden = false) => {
    var _a;
    const challengePricing = (_a = challenge === null || challenge === void 0 ? void 0 : challenge.settings) === null || _a === void 0 ? void 0 : _a.pricing;
    const challengePaidPlans = getChallengePaidPlans(challenge === null || challenge === void 0 ? void 0 : challenge.id, userPaidPlans) || [];
    const isFree = isChallengeFree(challengePricing, challengePaidPlans.length);
    const isHasSinglePayment = !!(challengePricing === null || challengePricing === void 0 ? void 0 : challengePricing.singlePayment);
    const isHiddenOnly = isHiddenPlansOnly(isHasSinglePayment, challengePaidPlans) && !ignoreHidden;
    if (isHiddenOnly) {
        return t(hiddenPlansOnlyKey);
    }
    if (isFree) {
        return t(freeKey);
    }
    const singlePayment = isHasSinglePayment
        ? serverPricingToClientPriceAndCurrencyString(challengePricing)
        : null;
    const plansJoinedName = getPaidPlansJoinedName(t, challengePaidPlans, joinedKey, !ignoreHidden);
    return isHasSinglePayment && plansJoinedName
        ? `${singlePayment} ${t(separatorKey)} ${plansJoinedName}`
        : singlePayment || plansJoinedName || '';
};
//# sourceMappingURL=price.js.map